import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  selectedAE: 'ae1'
};

const aeSlice = createSlice({
  name: 'ae',
  initialState,
  reducers: {
    setSelectedAE: (state, action) => {
      state.selectedAE = action.payload;
    }
  }
});

export const { setSelectedAE } = aeSlice.actions;
export default aeSlice.reducer;